import { CloseBid, ClosedBidStatus } from 'Interfaces/closeBids';

const noClosedBidAndHaveProviderCallable = (closeBids: CloseBid[]): boolean => {
    const existCovered = closeBids.some((closeBid) => closeBid.status === ClosedBidStatus.covered);
    const existCallable = closeBids.some((closeBid) => closeBid.status === ClosedBidStatus.callable);
    return !existCovered && existCallable;
};

export { noClosedBidAndHaveProviderCallable };